"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Point {
    constructor(_x, _y) {
        this._x = _x;
        this._y = _y;
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
}
exports.Point = Point;
//# sourceMappingURL=Point.js.map